module.exports = __webpack_public_path__ + "static/media/Becky-Lou - Pastel.48f85550.jpg";


/*****************
 ** WEBPACK FOOTER
 ** ./src/assets/img/Becky-Lou - Pastel.jpg
 ** module id = 386
 ** module chunks = 0
 **/